function formatNumber(num) {
    if(num<10) {
        const formatnum =  num.toString().padStart(2, '0');
            return formatnum
    }
    else {
        return num
    }
  }

export function formatNumberWithCommas(num) {
  if (num === null || num === undefined || isNaN(num)) {
    return num;
  }
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default formatNumber;